import { Box, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import CustomSelect from "../../../../../../Components/CustomSelect";
import DataService from "../../../../../../Service";
import SettingsIcon from "@material-ui/icons/Settings";
import DashboardChartService from "../DashboardChartService";
import chartConstants from "../ChartConstants";
import ChartLoader from "../ChartLoader";
import NotFoundFallback from "../AssignmentGraphs/NotFoundFallBack";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  selectClients: {
    "& .MuiSelect-select": {
      padding: "5px 8px !important",
    },
  },
}));

const AssignmentsByGraph = (props) => {
  const { plainView } = props;
  const { id: organisationId } = props.organisationId;
  const classes = useStyles();
  const [typeOpen, setTypeOpen] = useState(false);
  const [currentTypeChartDataArr, setCurrentTypeChartDataArr] = useState([]);
  const [typeChecked, setTypeChecked] = useState({});
  const [userData, setUserData] = useState({
    assignment: "Level of seniority",
  });
  const assignmentByTypeLayout = { ...chartConstants.data };
  assignmentByTypeLayout.datasets[0].label = "Number of assignments";
  const [assignmentByType, setAssignmentByType] = useState(chartConstants.data);
  const [assignmentOptionsArr, setAssignmentOptionsArr] = useState([]);

  const [chartLoader, setChartLoader] = useState(true);
  console.log(organisationId, "organ id");
  //
  const onChangeItem = (selectedItemValue, inputId, routeFrom) => {
    setUserData((prev) => ({
      ...prev,
      [selectedItemValue.id]: selectedItemValue.value,
    }));
    if (selectedItemValue.id === "assignment") {
      getAssignmentBytypeGraph(organisationId, selectedItemValue.value);
    }
  };
  useEffect(() => {
    // getAssignmentBytypeGraph(organisationId,userData.assignment)
    getAssignmentOption(organisationId);
  }, [organisationId]);

  const getAssignmentBytypeGraph = (organisationId, assignmentType) => {
    const params = {
      filter: assignmentType || undefined,
      organisation_id: organisationId || undefined,
    };
    DataService.getDirectData("dashboards/assignments_graph", {
      ...params,
    }).then((response) => {
      setAssignmentByType((prev) => {
        const updatedAssignmentByType = { ...prev };
        const filteredData = response.data.filter(
          (el) => !(el.key === null || el.key === "") && el.value > 0
        );
        updatedAssignmentByType.datasets[0].data = filteredData.map(
          (el) => el.value
        );
        updatedAssignmentByType.labels = filteredData.map((el) => el.key);
        if (assignmentType === "Service") {
          updatedAssignmentByType.labels = filteredData.map(
            (e) => e.key.charAt(0).toUpperCase() + e.key.slice(1)
          );
        }
        updatedAssignmentByType.datasets[0].backgroundColor = props.graphColor;
        return updatedAssignmentByType;
      });
      let localArr = [];
      let checkedData = {};
      setAssignmentByType((prev) => {
        prev.labels.forEach((option, i) => {
          var pdata = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = prev.datasets[0].data[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        return prev;
      });
      setTypeChecked((prev) => ({ ...prev, ...checkedData }));
      setCurrentTypeChartDataArr(localArr);
      setChartLoader(false);
    });
  };

  const getAssignmentOption = (organisationId) => {
    DataService.getDirectData(
      "dashboards/assignments_graph_dropdown_options"
      // {"organisation_id":organisationId||undefined}
    ).then((response) => {
      assignmentOptionsArr.length = 0;
      setAssignmentOptionsArr(
        assignmentOptionsArr.concat(
          response.data.filter((el) => el !== "Status")
        )
      );
      setUserData({ ...userData, assignment: response.data[1] });
      getAssignmentBytypeGraph(organisationId, response.data[1]);
      setChartLoader(false);
    });
  };

  const handleClickTypeOpen = () => {
    setTypeOpen(true);
  };
  const handleTypeClose = (value) => {
    setTypeOpen(false);
  };

  const afterUpdateTypeGraph = (objArr, checkedArr) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    setAssignmentByType((prev) => {
      const newAssignmentByType = { ...prev };
      newAssignmentByType.datasets[0].data = filteredCurrentChartDataArr.map(
        (option, i) => option.value
      );
      newAssignmentByType.labels = filteredCurrentChartDataArr.map(
        (option, i) => option.name
      );
      return newAssignmentByType;
    });
    setTypeChecked(checkedArr);
    handleTypeClose();
  };
  const MainStyle = { boxShadow: 4, padding: 1 };
  if (plainView) {
    MainStyle.boxShadow = 0;
    MainStyle.padding = 0;
  }
  return (
    <Box width={"100%"}>
      <Box {...MainStyle} style={{ borderRadius: "5px" }}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={6}>
            <Typography
              variant="subtitle1"
              color="secondary"
              style={{
                height: "47px",
                alignItems: "center",
                display: "flex",
                paddingLeft: "26px",
              }}
              fontWeight="fontWeightBold"
            >
              Assignment by
            </Typography>
          </Grid>
          <Grid item xs={5} className="select_option_assignment_by_graph">
            <CustomSelect
              className={classes.selectClients}
              id="assignment"
              labelText="Select Clients"
              displayEmpty
              hideLable
              variant="outlined"
              itemArr={assignmentOptionsArr}
              parentcall={onChangeItem}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              defaultValue={userData.assignment}
            />
          </Grid>
          <Grid
            item
            xs={1}
            className="settings_icon_assignment_by_graph"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SettingsIcon
              style={{ cursor: "pointer" }}
              onClick={handleClickTypeOpen}
            />
          </Grid>
        </Grid>

        <Box width={1}>
          {chartLoader ? (
            <ChartLoader />
          ) : (
            <AssignmentByTypeBar
              organisation={userData.organisation}
              assignmentByType={assignmentByType}
              options={chartConstants.options}
            />
          )}
        </Box>
      </Box>
      {typeOpen && (
        <DashboardChartService
          assignmentList={true}
          currentChartDataArr={currentTypeChartDataArr}
          setCurrentChartDataArr={setCurrentTypeChartDataArr}
          afterUpdateGraph={afterUpdateTypeGraph}
          open={typeOpen}
          handleClose={handleTypeClose}
          grpahChecked={typeChecked}
        />
      )}
    </Box>
  );
};

export default AssignmentsByGraph;

//////

const AssignmentByTypeBar = React.memo(
  (props) => {
    const dataLength = props.assignmentByType.datasets[0].data.length;
    const labelLength = props.assignmentByType.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random() * 1232151 + 1}
            id={props.organisation}
            data={props.assignmentByType}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByType) ===
      JSON.stringify(nextProps.assignmentByType)
    );
  }
);
